module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div tabindex="0" class="apexchat_overlay_content fluid-width" id="opt_in_consent">\r\n    <div class="livechat_consent_text">\r\n        ' +
((__t = (text )) == null ? '' : __t) +
'\r\n    </div>\r\n    <div style="margin-top: 10px;margin-bottom: 10px;">\r\n        <button class="livechat_consent_agree livechat_button livechat_button_large livechat_primary_button">Yes, I\r\n            Agree\r\n        </button>\r\n        <button class="livechat_consent_warning livechat_button livechat_button_text livechat_button_text_dull">Not\r\n            Agreed\r\n        </button>\r\n    </div>\r\n</div>';

}
return __p
}